import {hideOnClickOutside} from "../utils/utils";
export default class Dialog {
	constructor(element) {
		// The dialog to be opened
		this.dialog 				= element;
		// The elements that open the dialog
		this.dialogOpeners			= document.querySelectorAll(`[data-dialog='${this.dialog.id}']`);
		// Functions and states
		this.openDialog				= this.openDialog.bind(this);
		this.closeDialog			= this.closeDialog.bind(this);
		this.hideOnClickOutside		= this.hideOnClickOutside.bind(this);
		this.open					= false;


		// Adding a data attribute of noscroll to the dialog will prevent the page from scrolling when the dialog is open
		if(this.dialog.hasAttribute("data-noscroll") == true){ 
			this.noscroll = true;
		}


		// CHECK IF THIS DIALOG IS A BUTTON OR SPAN
		// - In which case we treat it differently
		if( this.dialog && (this.dialog.tagName == 'BUTTON' || this.dialog.tagName == 'SPAN') ){
			this.dialog.addEventListener("click", (event) => {
				let dialog = event.target.closest('[data-component="dialog"]');
				
				if (dialog.classList.contains('pill--active') && dialog.classList.contains('dialog--open')) {
					dialog.classList.remove("pill--active");
					dialog.classList.remove("dialog--open");
				}
				if (!dialog.classList.contains('pill--active') && !dialog.classList.contains('dialog--open')) {
					dialog.classList.add("pill--active");
					dialog.classList.add("dialog--open");
				}
				
				// Notice this is using the original hideOnClickOutside function
				hideOnClickOutside(dialog, null, ['pill--active', 'dialog--open']);
			})
		}


		//
		// If an element on the page has a data attribute of data-dialog which matches the id of this.dialog
		// then it will add an event listener and bind them
		//
		this.dialogOpeners && this.dialogOpeners.forEach( (dialogOpener) => {
			dialogOpener.addEventListener("click", (event) => {
				event.preventDefault()

				if(this.open === true){
					this.closeDialog(this.dialog, this.noscroll)
				} else {
					this.openDialog(this.dialog, this.noscroll)
				}
			})
		})
		
	}

	openDialog(dialog, noscroll){

		if(this.open === true)
			return;

		dialog.classList.add('pill--active')
		dialog.classList.add('dialog--open')
		
		this.dialogOpeners && this.dialogOpeners.forEach( (dialogOpener) => {
			dialogOpener.classList.add('pill-button--active')
		});

		// Pause scroll if set as data attribute
		if(noscroll){
			// console.log('open dialog and pause scroll');
			window.app.smoother && window.app.smoother.paused(true);
			document.body.classList.add('no-scroll');
		}

		// Create listener for clicking outside of the dialog
		this.hideOnClickOutside( dialog )
		
		this.open = true;
	}

	closeDialog(dialog, noscroll){
		this.open = false;

		dialog.classList.remove('pill--active')
		dialog.classList.remove('dialog--open')
		this.dialogOpeners && this.dialogOpeners.forEach( (dialogOpener) => {
			dialogOpener.classList.remove('pill-button--active')
		});

		if(noscroll){
			window.app.smoother && window.app.smoother.paused(false);
			document.body.classList.remove('no-scroll');
			// console.log( 'resume scroll' );
		}

	}

	hideOnClickOutside = (element) => {
		const outsideClickListener = event => {
			// console.log( event.target.parentNode, element.id );
			if (!element.contains(event.target) ) {
	
				if( event.target.parentNode.dataset.dialog === element.id ) {
					return;
				}

				this.closeDialog(this.dialog, this.noscroll);
				// console.log('close dialog from outside click');

				removeClickListener();

			}
		}
	
		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener);
		}

		document.addEventListener('click', outsideClickListener);
	
	}
}
